import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import { ExperimentAssetBrowser, ExperimentEditStep } from '../';

import './ExperimentEditReview.scss';

class ExperimentEditReview extends Component {
  getI18nID(suffix) {
    return `components.experiment.experimentWizard.${suffix}`;
  }

  renderMissingImages() {
    return (
      <p className="error">
        <FormattedMessage id={this.getI18nID('review.minimumImage')} />
      </p>
    );
  }

  renderImages() {
    const assets = this.props.experiment.content_test_assets || [];
    const columns = [
      { name: 'thumbnail', sortable: false, width: '62px' },
      { name: 'name', sortable: false },
      { name: 'redirect_url', sortable: false }
    ];
    return (
      <div className="assetpicker">
        <ExperimentAssetBrowser columns={columns} assets={assets} />
      </div>
    );
  }

  render() {
    const { actions, experiment } = this.props;
    const { formatMessage, formatNumber } = this.props.intl;
    const assets = this.props.experiment.content_test_assets || [];
    const testName = experiment.name;
    const testDescription = experiment.description;
    const testEngine = experiment.engine_name?.toLowerCase();
    const testTrigger =
      testEngine === 'ecs' ? 'ecs' : experiment.end_trigger?.toLowerCase();
    const testMode = formatMessage({
      id: this.getI18nID(`review.testMode.${testEngine}`)
    });
    const testWinner = formatMessage(
      {
        id: this.getI18nID(
          `review.testMode.endTrigger.${testEngine}.${testTrigger}`
        )
      },
      { endValue: formatNumber(experiment.end_value) }
    );
    const numImages = assets.length;
    const hasImages = numImages > 1;
    const imageTitle = hasImages
      ? formatMessage(
          { id: this.getI18nID('review.contentCount') },
          { count: formatNumber(numImages) }
        )
      : formatMessage({ id: this.getI18nID('review.content') });

    return (
      <div className="experiment-container slds-grid">
        <ExperimentEditStep actions={actions} canNav={true} step="step3" />
        <div className="review slds-col">
          <p className="review-container-title">
            {formatMessage({ id: this.getI18nID('review.header') })}
          </p>
          <div className="review-test">
            <p className="review-container-title">
              {formatMessage({ id: this.getI18nID('review.info') })}
            </p>
            <p className="label">
              {formatMessage({ id: this.getI18nID('fields.name') })}
            </p>
            <p className="field">{testName}</p>

            <p className="label">
              {formatMessage({ id: this.getI18nID('fields.description') })}
            </p>
            <p className="field">{testDescription}</p>
          </div>
          <div className="break" />
          <div className="review-image">
            <p className="image-container-title">{imageTitle}</p>
            {hasImages ? this.renderImages() : this.renderMissingImages()}
          </div>
          <div className="break" />
          <div className="review-test">
            <p className="review-container-title">
              {formatMessage({ id: this.getI18nID('review.settings') })}
            </p>
            <div className="review-winner">
              <p className="label">
                {formatMessage({ id: this.getI18nID('fields.testMode') })}
              </p>
              <p className="field">{testMode}</p>
            </div>
            <div className="review-winner">
              <p className="label">
                {formatMessage({
                  id: this.getI18nID('review.testMode.endTrigger.title')
                })}
              </p>
              <p className="field">{testWinner}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ExperimentEditReview.propTypes = {
  actions: PropTypes.object,
  experiments: PropTypes.object,
  modals: PropTypes.object,
  experiment: PropTypes.object,
  mode: PropTypes.oneOf(['edit', 'create']),
  intl: intlShape.isRequired
};

export default injectIntl(ExperimentEditReview);
